import request from "@/common/utils/request.js";
import { getInfo, getDomain } from "@/api/cookies";

import { WebClient } from "@/api/webClient";
const webClient = new WebClient();
export class HomeClient extends WebClient {
  async getDnsOneApi() {
    const data = await request({
      url: `/system/pc/systemData/getDnsOneApi`,
      method: "GET",
      params: { domain: location.host },
    });
    webClient.functionNo(data);
    return data;
  }
  async loginByPwd(item) {
    const data = await request({
      url: "/oauth/oem/student/auth/loginByPassword",
      method: "POST",
      data: item,
    });
    webClient.functionThen(data);
    return data;
  }
  // 获取验证码图片
  async getVerifyCode() {
    return await request({
      url: "/outside/getVerifyCode",
    });
  }
  // 获取手机验证码(加密版)
  async sendCodeJxy(data) {
    return await request({
      url: "/system/user/sendCodeJxy",
      data,
      method: "POST",
    });
  }
  // 获取手机验证码(修改手机号用)
  async sendCode(data) {
    return await request({
      url: "/system/user/sendCode",
      data,
      method: "POST",
    });
  }
  // 获取接口返回密钥地址
  async getSendSmsSecretKey() {
    return await request({
      url: "/system/user/getSendSmsSecretKey",
    });
  }
  async loginBySms(item) {
    return await request({
      url: "/oauth/oem/student/auth/loginBySms",
      method: "POST",
      data: {
        smsTel: item.smsTel,
        smsVerificationCode: item.smsVerificationCode,
        loginTypeCode: 2,
      },
    });
  }
  async getUserInfo(userId) {
    return await request({
      url: "/system/user/getDataInfoById",
      params: {
        userId,
      },
    });
  }
  async registerNew(item) {
    const data = await request({
      url: "/oauth/oem/student/auth/register",
      method: "POST",
      data: {
        password: item.password,
        phone: item.phone,
        code: item.code,
        loginTypeCode: 2,
      },
    });
    this.functionThen(data);
    return data;
  }
  async checkVerification(code, key) {
    return await request({
      url: `/outside/checkVerification?code=${code}&key=${key}`,
      method: "POST",
    });
  }
  /**检测手机号是否已被注册*/
  async checkExistTel(phone) {
    return await request({
      url: "/system/user/getUserIdByPhone",
      method: "GET",
      params: {
        phone,
      },
    });
  }
  async forgetPwd(phone, password, code) {
    const data = await request({
      url: "/system/user/forgetPassword",
      method: "POST",
      data: {
        phone,
        code,
        password,
      },
    });
    this.functionThen(data);
    return data;
  }
  async getAgreementDetails(type) {
    let data = await request({
      url: `/system/pc/systemData/getAgreementDetails`,
      method: "GET",
      params: {
        type: type,
      },
    });
    return data;
  }
  getSurfacePcList(item) {
    const data = request({
      url: `/system/pc/systemData/getSurfacePcList`,
      method: "GET",
      params: {
        type: item.type,
        entrantsId:
          item.entrantsId || item.entrantsId === 0 ? item.entrantsId : null,
        showStatus: 1,
        entrantsType: item.entrantsType,
      },
    });
    return data;
  }

  getTenantKindZyList() {
    return request({
      url: "/system/pc/systemData/getTenantKindZyList",
      method: "GET",
      params: {
        productLine: 1,
      },
    });
  }

  async getLiveshowplaybackByTypes(item) {
    const data = await request({
      url: `/course/pc/courseData/getLiveshowplaybackByTypes`,
      method: "GET",
      params: item,
    });
    return data;
  }
  async qbsJxyCourse(item) {
    const data = await request({
      url: `/course/pc/courseData/qbsJxyCourse`,
      method: "GET",
      params: item,
    });
    return data;
  }
  qbsJxyTutorial(item) {
    return request({
      url: "/course/pc/tutorialData/qbsJxyTutorial",
      method: "GET",
      params: item,
    });
  }
  getLbClassCourseById(liveid, classId, coursePackageId) {
    return request({
      url: "/ucenter/api/home/getLbClassCourseByIdS",
      method: "GET",
      params: {
        // 直播课id
        liveid: liveid,
        classId: classId || null,
        coursePackageId: coursePackageId || null,
        userid: localStorage.getItem("userId"),
      },
    });
  }
  // 获取学院列表信息(新 2022.10.13)
  getTenantKindNoZyList(item) {
    return request({
      url: `/system/pc/systemData/getTenantKindNoZyList`,
      method: "GET",
      params: item,
    });
  }
  async getCourseListTypes(item) {
    const res = await request({
      url: `/system/pc/systemData/getCourseListTypes`,
      method: "GET",
      params: item,
    });
    return res;
  }
  // 专业，省份 下的课程列表
  async selectProvinceKechengList(item) {
    const data = await request({
      url: `/outside/jxyData/provinceCollegesKeCheng/selectProvinceKechengList`,
      method: "GET",
      params: item,
    });
    return data;
  }
  getTenantBoutiqueProvinceList(params) {
    return request({
      url: `/system/pc/systemData/getTenantBoutiqueProvinceList`,
      method: "GET",
      params,
    });
  }
  getTenantKcProvinceList(params) {
    return request({
      url: `/system/pc/systemData/getTenantKcProvinceList`,
      method: "GET",
      params,
    });
  }
  async queryOpenCourse(params) {
    return request({
      url: "/marketing/jxy/open/queryOpenCourse",
      method: "GET",
      params,
    });
  }
  async addBrowseJxyFrequency(params) {
    return request({
      url: "/marketing/jxy/open/addBrowseJxyFrequency",
      method: "POST",
      params,
    });
  }
  // 首页机构下的班型类型列表
  selectPageListToIndexType(item) {
    return request({
      url: `/system/pc/systemData/selectPageListToIndexType`,
      method: "GET",
      params: item,
    });
  }
  // 知识套餐详情
  async qbsJxyTutorialById(item) {
    return request({
      url: "/course/pc/tutorialData/qbsJxyTutorialById",
      method: "GET",
      params: item,
    });
  }
  async getCollectFlgbyUser(params) {
    const data = await request({
      url: `/knowledge/collect/getCollectFlgbyUser`,
      method: "GET",
      params,
    });
    this.functionNo(data);
    return data;
  }
  async updateCollect(params) {
    const data = await request({
      url: `/knowledge/collect/updateCollect`,
      method: "POST",
      data: params,
    });
    this.functionThen(data);
    return data;
  }
  async classesContactTableButton(params) {
    const data = await request({
      url: `/knowledge/jxyClassesData/classesContactTableButton`,
      method: "GET",
      params,
    });
    this.functionNo(data);
    return data;
  }
  async classesDocKcTableButton(params) {
    const data = await request({
      url: `/knowledge/jxyClassesData/classesDocKcTableButton`,
      method: "GET",
      params,
    });
    this.functionNo(data);
    return data;
  }
  async classesCourseTableList(params) {
    const data = await request({
      url: `/course/pc/tutorialData/classesCourseTableList`,
      method: "GET",
      params,
    });
    this.functionNo(data);
    return data;
  }
  async queryJxyTeacherList(params) {
    const data = await request({
      url: `/course/pc/tutorialData/queryJxyTeacherList`,
      method: "GET",
      params,
    });
    this.functionNo(data);
    return data;
  }
  async getQueryCourseDate(coachClassTypeId) {
    return await request({
      url: `/course/tutorial/queryPaperDate`,
      params: {
        coachClassTypeId,
      },
    });
  }
  async queryTutorialCourse(item) {
    return await request({
      url: `/course/tutorial/queryTutorialCourse`,
      params: item,
    });
  }
  async queryClassEvaluate(item) {
    return await request({
      url: `/course/evaluate/queryClassEvaluate`,
      params: item,
    });
  }
  async addClassEvaluate(item) {
    let res = await request({
      url: `/course/evaluate/addClassEvaluate`,
      method: "POST",
      data: item,
    });
    this.functionThen(res);
    return res;
  }
  getClassRelevant(item) {
    return request({
      url: "/kecheng/pc/classes/getClassRelevant",
      method: "GET",
      params: item,
    });
  }
  classesButtonKcDataList(item) {
    return request({
      url: "/knowledge/jxyClassesData/classesButtonKcDataList",
      method: "GET",
      params: item,
    });
  }
  async getDocsPcPageList(params) {
    const data = await request({
      url: `/knowledgeSystem/webPc/getDocsPcPageList`,
      method: "GET",
      params,
    });
    return data;
  }
  async getContactPcPageList(params) {
    const data = await request({
      url: `/knowledgeSystem/webPc/getContactPcPageList`,
      method: "GET",
      params,
    });
    return data;
  }
  async getAccessKey() {
    const data = await request({
      url: `/system/pc/systemData/tspResManage/getAccessKey`,
      method: "POST",
    });
    return data;
  }
  async getCourseMaterialList(params) {
    const data = await request({
      url: `/course/pc/tutorialData/getCourseMaterialList`,
      method: "GET",
      params,
    });
    return data;
  }
  async queryCourseJxyDetails(params) {
    const data = await request({
      url: `/course/pc/courseData/queryCourseJxyDetails`,
      method: "GET",
      params,
    });
    return data;
  }
  async getNewPaperTopicById(params) {
    const data = await request({
      url: `/knowledge/xlcwx/question/getNewPaperTopicById`,
      method: "GET",
      params,
    });
    return data;
  }
  async getNewPaperResult(params) {
    const data = await request({
      url: `/knowledge/xlcwx/question/getNewPaperResult`,
      method: "GET",
      params,
    });
    return data;
  }
  async newSubmitPaper(sub) {
    const fromData = JSON.parse(JSON.stringify(sub));
    for (const item of fromData.data.paperTopicList) {
      if (item.questionType == 1 || item.questionType == 6) {
        await item.userAnswer.sort();
        item.userAnswer = item.userAnswer.join(",");
      } else if (item.questionType == 5) {
        for (const chil of item.subTopicList) {
          if (chil.questionType == 1 || chil.questionType == 6) {
            if (chil.userAnswer) {
              await chil.userAnswer.sort();
            }
            chil.userAnswer = chil.userAnswer.join(",");
          }
        }
      }
    }
    const data = await request({
      url: `/question/xlcwx/question/newSubmitPaper`,
      method: "POST",
      data: fromData,
    });
    this.functionThen(data);
    return data;
  }
  async addAnswerQuestion(params) {
    const data = await request({
      url: `/teach/question/addAnswerQuestion`,
      method: "POST",
      data: params,
    });
    return data;
  }
  getKnowledgePointsList(params) {
    return request({
      url: "/course/knowledge/points/getKnowledgePointsList",
      method: "GET",
      params,
    });
  }
  getPointsTextbookList(params) {
    return request({
      url: "/course/knowledge/points/getPointsTextbookList",
      method: "GET",
      params,
    });
  }
  getPointsTypeDataList(params) {
    return request({
      url: "/course/knowledge/points/getPointsTypeDataList",
      method: "GET",
      params,
    });
  }
  queryCourseJxyDetails(params) {
    return request({
      url: "/course/pc/courseData/queryCourseJxyDetails",
      method: "GET",
      params,
    });
  }
  getContactPcPageList(params) {
    return request({
      url: "/knowledgeSystem/webPc/getContactPcPageList",
      method: "GET",
      params,
    });
  }
  getDocsPcPageList(params) {
    return request({
      url: "/knowledgeSystem/webPc/getDocsPcPageList",
      method: "GET",
      params,
    });
  }
  getTeacherInfoById(params) {
    return request({
      url: "/course/pc/courseData/getTeacherInfoById",
      method: "GET",
      params,
    });
  }
  getPackageList(params) {
    return request({
      url: "/knowledge/mobile/xlcwx/material/getPackageList",
      method: "GET",
      params,
    });
  }
  getPackageInfoById(params) {
    return request({
      url: "/knowledge/xlcwx/material/getPackageInfoById",
      method: "GET",
      params,
    });
  }
  getMaterialsMajorDataList(params) {
    return request({
      url: "/knowledge/xlcwx/material/getMaterialsMajorDataList",
      method: "GET",
      params,
    });
  }
  getTenantLearnMaterialsZyList(params) {
    return request({
      url: "/knowledge/xlcwx/material/getTenantLearnMaterialsZyList",
      method: "GET",
      params,
    });
  }
  getDataList(params) {
    return request({
      url: "/system/dictionary/getDataList",
      method: "GET",
      params,
    });
  }
  getPaperPackageList(params) {
    return request({
      url: "/knowledge/xlcwx/question/getPaperPackageList",
      method: "GET",
      params,
    });
  }
  getPaperListByPackageId(params) {
    return request({
      url: "/knowledge/xlcwx/question/getPaperListByPackageId",
      method: "GET",
      params,
    });
  }
  getPackageMajor(params) {
    return request({
      url: "/knowledge/xlcwx/question/getPackageMajor",
      method: "GET",
      params,
    });
  }
  getNewList(params) {
    return request({
      url: "/knowledge/paper/getNewList",
      method: "GET",
      params,
    });
  }
  getList(params) {
    return request({
      url: "/knowledge/tob/pc/curriculum/getList",
      method: "GET",
      params,
    });
  }
  queryCourseDetails(params) {
    return request({
      url: "/knowledge/tob/pc/curriculum/queryCourseDetails",
      method: "GET",
      params,
    });
  }
  getRecordList(params) {
    return request({
      url: "/knowledge/learningCenter/record/getRecordList",
      method: "GET",
      params,
    });
  }
  queryCourseDetails(params) {
    return request({
      url: "/course/curriculum/queryCourseDetails",
      method: "GET",
      params,
    });
  }
  queryCourseDetails(params) {
    return request({
      url: "/course/curriculum/queryCourseDetails",
      method: "GET",
      params,
    });
  }
  dateAnyDailyPractice(params) {
    return request({
      url: "/study/dailyPractice/dateAnyDailyPractice",
      method: "GET",
      params,
    });
  }
  getStudentWorkList(params) {
    return request({
      url: "/study/work/student/getStudentWorkList",
      method: "GET",
      params,
    });
  }
  getMyRoomList(params) {
    return request({
      url: "/knowledge/tob/pc/myRoom/getMyRoomList",
      method: "GET",
      params,
    });
  }
  getClassTopicList(params) {
    return request({
      url: "/knowledge/mobile/questionAi/getClassTopicList",
      method: "GET",
      params,
    });
  }
  getDataList(params) {
    return request({
      url: "/system/dictionary/getDataList",
      method: "GET",
      params,
    });
  }

  getRecentLiveList(params) {
    return request({
      url: "/knowledge/learningCenter/recentLive/getRecentLiveList",
      method: "GET",
      params,
    });
  }
  async getCourseTitleBrushInfo(params) {
    return await request({
      url: "/knowledge/brush/question/getCourseTitleBrushInfo",
      params,
    });
  }
  async getErrorProneTopic(params) {
    return await request({
      url: "/knowledge/brush/question/getErrorProneTopic",
      params,
    });
  }
  async getClassTopicList(params) {
    return await request({
      url: "/knowledge/mobile/questionAi/getClassTopicList",
      params,
    });
  }
  async getBuyPaperAndPckList(params) {
    return await request({
      url: "/knowledge/tob/pc/paper/getBuyPaperAndPckList",
      params,
    });
  }
  async getUserWrongTopic(params) {
    return await request({
      url: "/question/wrong/question/getUserWrongTopic",
      params,
    });
  }
  async getMaterialBuyList(params) {
    return await request({
      url: "/knowledge/learningCenter/material/getMaterialBuyList",
      params,
    });
  }
  async getClassSemester(params) {
    return await request({
      url: "/knowledge/learningCenter/class/getClassSemester",
      params,
    });
  }
  async getCourseSemesterList(params) {
    return await request({
      url: "/knowledge/tob/pc/curriculum/getCourseSemesterList",
      params,
    });
  }
  async getCourseInfoByCourseNameId(params) {
    return await request({
      url: "/knowledge/tob/pc/curriculum/getCourseInfoByCourseNameId",
      params,
    });
  }
  async getNewestSemester(params) {
    return await request({
      url: "/knowledge/learningCenter/class/getNewestSemester",
      params,
    });
  }
  async getSemesterTypeChapter(params) {
    return await request({
      url: "/knowledge/tob/pc/curriculum/getSemesterTypeChapter",
      params,
    });
  }
  async getSemesterVideoNode(params) {
    return await request({
      url: "/knowledge/tob/pc/curriculum/getSemesterVideoNode",
      params,
    });
  }
  async getUserTopicTypeNumber(params) {
    return await request({
      url: "/knowledge/collect/getUserTopicTypeNumber",
      params,
    });
  }
  async getWrongTopicTypeList(params) {
    return await request({
      url: "/knowledge/v2/wrong/topic/getWrongTopicTypeList",
      params,
    });
  }
  async getBrushRecord(params) {
    return await request({
      url: "/knowledge/brush/question/getBrushRecord",
      params,
    });
  }
  async getScreenSubject(params) {
    return await request({
      url: "/knowledge/brush/question/getScreenSubject",
      params,
    });
  }
  async queryOpenCourseBeyId(params) {
    return await request({
      url: "/marketing/open/queryOpenCourseBeyId",
      params,
    });
  }
  async queryPurchaseCourse(coachClassTypeId) {
    return await request({
      url: `/course/tutorial/queryPurchaseCourse?coachClassTypeId=${coachClassTypeId}`,
    });
  }
  async getCoachInfo(coachClassTypeId) {
    return await request({
      url: `/course/tutorial/qbsTutorialById`,
      params: {
        coachClassTypeId,
      },
    });
  }
  async getOrderDetilsById(orderNum) {
    return await request({
      url: `/orders/pay/getPayOrdersByOrderNum?orderNum=${orderNum}`,
    });
  }
  async addPayOrders(itemsDtoList, couponCode) {
    let res = await request({
      url: `/orders/pay/addPayOrders`,
      method: "POST",
      data: {
        itemsDtoList,
        couponCode,
      },
    });
    this.functionThen(res);
    return res;
  }
  async getOrderDetilsById(orderNum) {
    return await request({
      url: `/orders/pay/getPayOrdersByOrderNum?orderNum=${orderNum}`,
    });
  }
  async orderMyOrder(orderNum, payTypeMark) {
    return await request({
      url: `/orders/pay/orderPay`,
      method: "POST",
      data: {
        orderNum,
        payTypeMark,
      },
    });
  }
  async getOrderDetilsById(orderNum) {
    return await request({
      url: `/orders/pay/getPayOrdersByOrderNum?orderNum=${orderNum}`,
    });
  }
  async getCourseDataLiveVo(item) {
    return await request({
      url: `/course/pc/courseData/getCourseDataLiveVo`,
      params: item,
    });
  }
  async queryCourseJxyDetails(item) {
    return await request({
      url: `/course/pc/courseData/queryCourseJxyDetails`,
      params: item,
    });
  }
  async getExerciseQuestion(item) {
    return await request({
      url: `/knowledge/brush/question/getExerciseQuestion`,
      params: item,
    });
  }
  async updateCollect(data) {
    return await request({
      url: "/knowledge/collect/updateCollect",
      method: "POST",
      data,
    });
  }
  async submitExercise(data) {
    return await request({
      url: "/knowledge/brush/question/submitExercise",
      method: "POST",
      data,
    });
  }
  async checkIsBuyByCommodityId(item) {
    return await request({
      url: `/course/pc/courseData/checkIsBuyByCommodityId`,
      params: item,
    });
  }
  // 查看解析
  async getBrushAnalysis(params) {
    return await request({
      url: "/knowledge/brush/question/getBrushAnalysis",
      params,
    });
  }
  async cleanBrushQuestion(data) {
    return await request({
      url: "/knowledge/brush/question/cleanBrushQuestion",
      method: "POST",
      data,
    });
  }
  async getCourseMaterialListByClassTypeId(params) {
    return await request({
      url: "/knowledge/learningCenter/material/getCourseMaterialListByClassTypeId",
      params,
    });
  }
  //专属教材
  async exclusiveMatByClassId(pageNum, pageSize, classTypeId) {
    return await request({
      url: `/knowledge/learningCenter/teachingMaterial/getTeachingMaterialListByClassId?pageNum=${pageNum}&pageSize=${pageSize}&classTypeId=${classTypeId}`,
    });
  }
  //专属考场
  async getExclusiveToClass(coachClassTypeId) {
    return await request({
      url: `/course/tutorial/queryTutorialRoom?coachClassTypeId=${coachClassTypeId}`,
    });
  }
  async qbsCoachClassTypeClassMeeting(coachClassTypeId) {
    return await request({
      url: `/knowledge/admin/classTypeClassMeeting/qbsCoachClassTypeClassMeeting?coachClassTypeId=${coachClassTypeId}`,
    });
  }
  async updateUserWrongTopic(getUserWrongQuestionVO) {
    let data = await request({
      url: "/question/wrong/question/updateUserWrongTopic",
      method: "POST",
      data: getUserWrongQuestionVO,
    });
    this.functionThen(data);
    return data;
  }
  async getDailyPracticeTopic(params) {
    return await request({
      url: "/study/dailyPractice/getDailyPracticeTopic",
      params,
    });
  }
  async getDailyPracticeAnalysis2(params) {
    return await request({
      url: `/question/daily/practice/getDailyPracticeAnalysis`,
      params,
    });
  }
  async addUserDailyPracticeAnswer(obj) {
    return await request({
      url: `/question/daily/practice/addUserDailyPracticeAnswer`,
      method: "POST",
      data: obj,
    });
  }
  async recordPars(data) {
    return await request({
      url: "/knowledge/learningCenterNew/recordPars",
      method: "post",
      data,
    });
  }
  async cleanErrorQuestions(data) {
    return await request({
      url: "/knowledge/brush/question/cleanErrorQuestions",
      method: "POST",
      data,
    });
  }
  async whetherBuy(data) {
    return await request({
      url: "/orders/pay/whetherBuy",
      method: "get",
      params: data,
    });
  }
  async getDetails(id) {
    return await request({
      url: `/knowledge/xlcwx/question/getPaperPackageInfoById?id=${id}`,
    });
  }
  async getCollectFlgbyUser(data) {
    return await request({
      url: "/knowledge/collect/getCollectFlgbyUser",
      method: "get",
      params: data,
    });
  }
  async queryOpenRecommend(item) {
    return await request({
      url: `/marketing/open/queryOpenRecommend`,
      params: item,
    });
  }
  /* 查询当前用户可用优惠券 */
  async getMyCouponByKnowledgeProduct(productType, productId) {
    return await request({
      url: `/marketing/couponApi/getMyCouponByKnowledgeProduct`,
      params: {
        productType,
        productId,
        terminalType: "pc",
      },
    });
  }
    async getQuestionListByCourse(pageNum, pageSize, course, section, type) {
    return await request({
      url: `/teach/courseQuestion/getCourseDataList`,
      params: {
        pageNum,
        pageSize,
        course,
        section,
        type,
      },
    });
  }
  async addAnswerQuestion(data) {
    data.source = 2;
    let res = await request({
      url: `/teach/question/addAnswerQuestion`,
      method: "POST",
      data,
    });
    this.functionThen(res);
    return res;
  }
 async getAndroidDownloadPackage(data) {
    
    let res = await request({
      url: `/system/pc/systemData/getAndroidDownloadPackage`,
      method: "GET",
      params: data,
    });
    this.functionNo(res);
    return res;
  }
   async getWatchStatusPC(data) {
    
    let res = await request({
      url: `/knowledge/learning/getWatchStatusPC`,
      method: "GET",
      params: data,
    });
    this.functionNo(res);
    return res;
  }
    // 查询学生是否保存过
  async getIsSubmit(params) {
    return await request({
      url: "/study/work/student/getIsSubmit",
      params,
    });
  }
  // 获取作业详情
  async getWorkDetails(params) {
    return await request({
      url: "/study/work/student/getWorkDetails",
      params,
    });
  }
    // 保存作业当前进度
  async saveWorkProgress(data) {
    return await request({
      url: "/study/work/student/saveWorkProgress",
      method: "POST",
      data,
    });
  }
    // 查询学生作答
  async getStudentAnswer(params) {
    return await request({
      url: "/study/work/student/getStudentAnswer",
      params,
    });
  }
    // 查询答疑内容
  async getWorkQuestionList(params) {
    return await request({
      url: "/teach/work/ask/getWorkQuestionList",
      params,
    });
  }
    // 提交作业
  async submitWork(data) {
    return await request({
      url: "/study/work/student/submitWork",
      method: "POST",
      data,
    });
  }
    // 添加作业答疑
  async addWorkAskQuestion(data) {
    return await request({
      url: "/teach/work/ask/addWorkAskQuestion",
      method: "POST",
      data,
    });
  }
  // 查询答疑内容
  async getWorkQuestionList(params) {
    return await request({
      url: "/teach/work/ask/getWorkQuestionList",
      params,
    });
  }
}
